<template>
  <div>
    <!--  <form-header :show-save-edit="false" :show-toolbox="false" :showDelete="true"-->
    <!--               :delete-enabled="selectedEntity"-->
    <!--               @delete=""-->
    <!--  >-->

    <grid-header :standalone="true" :showColumns="false"
                 :toolbox="toolbox"

                 :primaryEnabled="newEnabled"
                 :secondary-enabled="editEnabled"
                 :delete-enabled="deleteEnabled"
                 :primaryVisible="formConfig.writePermitted && showAdd"
                 :secondary-visible="formConfig.readPermitted && showDetails"
                 :show-delete="formConfig.readPermitted && showDetails && (mode !== 'select' || editInSelectMode)"
                 :buttonsStateWhileCategoryParent="buttonsStateWhileCategoryParent"

                 @search="filterGrid"
                 @delete-click="deleteEntity"
                 @primary-click="addEntity"
                 @secondary-click="showDetailsOrSelect"
    >
    </grid-header>

    <b-container class="px-0 mx-0" fluid="true" style="height: 100%">

      <VBox :scrollable="true">

        <EntitiesTree
            ref="tree"
            :form="formConfig"
            :excludedBranch="context ? context.excludedTreeBranch : null"
            v-model="selectedEntity"
            :filter="filter"
            :context="context"
            :recordsWithChosenFilters="recordsWithChosenFilters"
            :query="query"
            @multiSelectSizeChange.sync="multiSelectListSize"
            @childNodeMultiSelect="childNodeMultiSelect"
            @details="showDetailsOrSelect"
        ></EntitiesTree>
      </VBox>

      <FooterNavbar :data-test-path="'form-list-footer:' + formConfig.formClass">
        <template v-slot:info>
          <div v-if="(context && context.multiSelect && multiSelectListSize > 0)" style="width: 50px; text-align: left">
            &#9745; {{ multiSelectListSize }}
          </div>
        </template>
        <CloseButton @close="close" v-if="!context || context.mode === 'default'"></CloseButton>
        <footer-button type="Cancel" @cancel="close" v-else></footer-button>

        <footer-button type="Clear" @clear="clear" v-if="buttonsStateWhileCategoryParentForFooterButtons"></footer-button>
        <footer-button type="Select" @select="select" v-if="buttonsStateWhileCategoryParentForFooterButtons" :disabled="
        ((!context || !context.multiSelect) && !selectedEntity) ||
        ((context && context.multiSelect) && multiSelectListSize === 0) "></footer-button>
      </FooterNavbar>

    </b-container>
  </div>
</template>

<script>

import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import EntitiesList from "@/components/forms/EntitiesList";

import FooterButton from "@/components/navbar/FooterButton";
import FormsActions from "@/components/forms/FormsActions";
import FormsLoader from "@/components/forms/FormsLoader";
import CloseButton from "@/components/navbar/CloseButton";
import FormsListContext from "@/activity/templates/layouts/forms/FormsListContext"
import EntitiesTree from "@/components/forms/EntitiesTree";
import FormHeader from "@/components/forms/FormHeader";
import GridHeader from "@/components/datagrid/GridHeader";
import Events from "@/utils/Events";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import ProductWCLElements from "@/server/com/silkplm/model/plm/ProductWCLElements";

const ImportFormData = () => require("@/components/plm/ImportFormData");

export default {
  name: "FormsListTreeActivity",

  components: {GridHeader, FormHeader, EntitiesTree, CloseButton, FooterButton, EntitiesList, VBox, FooterNavbar},

  created() {
    if (this.context) {
      this.mode = this.context.mode;
      this.allowNullSelection =
          this.context?.allowNullSelection ??
          (this.context?.formValidatedFieldWithParent?.formFieldConfig?.allowNull && (this.context?.treeConfig && !this.context.treeConfig.fixedRoots)) ??
          true;
    }
    this.disableButtonsWhileCategoryParent();
  },
  async beforeMount() {
  },
  async mounted() {
    if(this.context?.formTitle){
      this.title = this.context.formTitle;
    }
    else{
      this.title = this.formConfig?.formTitle;
    }
    if (this.formConfig.writePermitted) {
      let importButton = new ToolboxButton().withIcon("file-arrow-up").withLabel($tr("import","Import"))
          .withAction(async (btn) => await this.openImportFile()).withVisible(this.formConfig.showImport);
      this.toolbox.push(importButton);
    }
    let exportButton = new ToolboxButton().withIcon("file-export").withLabel($tr("export","Export"))
        .withAction((btn) => this.generateExcel()).withVisible(this.formConfig.showExport);
    this.toolbox.push(exportButton);
  },

  methods: {

    disableButtonsWhileCategoryParent(){
      if (this.context && this.context.formValidatedFieldWithParent &&
          this.context.formValidatedFieldWithParent.label === 'Category Parent' &&
          this.mode === 'select'){
        this.buttonsStateWhileCategoryParent = false;
        this.buttonsStateWhileCategoryParentForFooterButtons = false;
      }
      else if(this.context === null){
        this.buttonsStateWhileCategoryParentForFooterButtons = false;
      }
      else if(this.mode === 'select' && this.allowNullSelection){
        this.buttonsStateWhileCategoryParent = true;
        this.buttonsStateWhileCategoryParentForFooterButtons = true;
      }
      else if(this.mode === 'select'){
        this.buttonsStateWhileCategoryParent = true;
        this.buttonsStateWhileCategoryParentForFooterButtons = true;
      }
    },

    async openImportFile() {
      await ActivityManager.showActivity(ImportFormData, {
        title: this.formConfig.formTitle,
        formClassLong: this.formConfig.formClassLong,
        masterId: null
      });
    },

    async generateExcel() {
      let items = await Rpc.Forms.listExtendedEntities(this.formConfig.formClassLong);
      let itemsId = [];
      for (let item of items) {
        itemsId.push(item.id)
      }

      await Rpc.ExcelExports.listExtendedEntities(
          null, null, this.formConfig.formId, itemsId).lock();
    },


    childNodeMultiSelect(node, isSelected) {
      // forward event to the parent node
      if (!isSelected) {
        this.localMultiSelection.delete(node.getKey());
      } else {
        this.localMultiSelection.set(node.getKey(), node.getValue());
      }

      this.multiSelectListSize = this.localMultiSelection.size;
      // let sel = this.context.multiSelect;

      this.$emit(Events.treeViewNodeMultiSelect, node, isSelected)
    },

    getTitle() {
      if (this.context?.activityType === Activity.SELECT) {
        return "Select " + this.formConfig?.entityName;
      }
      if (this.context?.activityType === Activity.SELECT_REPLACEMENT) {
        return "Select replacement for deleted " + this.formConfig?.entityName;
      }

      return this.formConfig?.formTitle;
    },


    capture() {
      // console.log("captured");
    },

    close() {
      ActivityManager.closeTopActivity();
    },

    filterGrid(query) {
      this.query = query;
    },
    async addEntity() {
      // if(this.mode === 'select' && !this.editInSelectMode){
      //   return;
      // }
      let treeConfig = this.formConfig?.extendedConfigs?.TreeConfig;

      let res = await this.$emit("add");
      let presetFields = [{
        fieldName: treeConfig.treeJoiningField,
        className: this.formConfig.formClassLong,
        value: this.selectedEntity?.element?.id,
        foreignValueInstance: this.selectedEntity,
        foreignValueLabel: this.selectedEntity?.name
      }];

      let context = new FormsListContext();
      context.treeConfig = treeConfig;

      this.customAdd || await FormsActions.create(this.formConfig,
          {presetFields, context});
    },

    async deleteEntity() {
      if (this.mode === 'select' && !this.editInSelectMode) {
        return;
      }
      let res = await this.$emit("delete");
      this.customDelete || await FormsActions.delete(this.selectedEntity.element, true);
    },

    select(data = null) {
      if (this.context?.multiSelect) {
        ActivityManager.findActivity(this).setResult([...this.localMultiSelection.values()]);
      } else {
        if(this.selectedEntity) {
          ActivityManager.findActivity(this).setResult(this.selectedEntity.element);
        }
        else {
          ActivityManager.findActivity(this).setResult(data.element);
        }
      }
      this.close();
    },

    clear() {
      ActivityManager.findActivity(this).setResult(null);
      this.close();
    },

    async showDetailsOrSelect(data) {
      if (this.mode === 'select') {
        return this.select(data);
      }
      await this.details();
    },

    async details() {
      if (this.mode === 'select' && !this.editInSelectMode) {
        return;
      }
      if (!this.showDetails) {
        return;
      }

      let res = await this.$emit("details");

      let treeConfig = this.formConfig?.extendedConfigs?.TreeConfig;
      let context = new FormsListContext();
      context.excludedTreeBranch = this.selectedEntity;
      context.treeConfig = treeConfig;
      this.customDetails || await FormsActions.editEntity(this.formConfig, this.selectedEntity.element,
          {context, showDelete: this.showDelete});
    },

    refreshSelection(selection) {
      if (!this.$refs.tree) {
        return;
      }

      this.isRootSelected = this.$refs.tree.isRootSelected();
      this.fixedRootsMode = this.$refs.tree.isfixedRootsMode();

      if (!selection) {
        this.newEnabled = !this.fixedRootsMode;
        this.deleteEnabled = false;
        this.editEnabled = false;
        return;
      }

      if (this.isRootSelected && this.fixedRootsMode) {
        this.editEnabled = true;
        this.newEnabled = true;
        this.deleteEnabled = false;
        return;
      }

      this.editEnabled = true;
      this.newEnabled = true;
      this.deleteEnabled = true;
    },
  },

  props: {
    formType: {required: true},
    showAdd: {default: true},
    showDelete: {default: true},
    showDetails: {default: true},
    filteringMode: {default: false},
    customDetails: {default: false},
    customAdd: {default: false},
    customDelete: {default: false},
    recordsWithChosenFilters: {default: null},

//    columnMixins: {type: Array, default:()=>[]},

    editInSelectMode: {default: false},
    context: {default: null},
    filter: {default: null},

  },

  model: {
    event: 'selected'
  },
  watch: {
    selectedEntity: function (val) {
      this.$emit('selected', val);
      this.refreshSelection(val);
    },
  },

  data: function () {
    return {
      query: "",
      multiSelectListSize: 0,
      localMultiSelection: new Map(),

      selectedEntity: null,
      isRootSelected: false,
      fixedRootsMode: false,

      formId: FormsLoader.detectFormConfig(this.formType).formId,
      formConfig: FormsLoader.detectFormConfig(this.formType),
      allowNullSelection: false,
      permissions: new PermissionsSet(),
      toolbox: [],

      newEnabled: true,
      deleteEnabled: true,
      editEnabled: true,

      mode: "browse",
      buttonsStateWhileCategoryParent: true,
      buttonsStateWhileCategoryParentForFooterButtons: true
    }
  },

}
</script>
